import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const ConfirmationModal = ({ confirmationTitle, confirmationMessage, isOpen, OnConfirm, OnCancel, }) => {
    return (React.createElement(Dialog, { open: isOpen, onClose: OnCancel, maxWidth: "xs", fullWidth: true },
        React.createElement(DialogTitle, { sx: { fontSize: "1.2em", textAlign: "center" } }, confirmationTitle),
        React.createElement(DialogContent, null,
            React.createElement(Typography, { variant: "body1", sx: {
                    textAlign: "center",
                    marginBottom: "10px",
                } }, confirmationMessage),
            React.createElement(Box, { sx: {
                    display: "flex",
                    justifyContent: "center", // Adjust as needed
                    alignItems: "center", // Adjust as needed
                } },
                React.createElement(Box, null,
                    React.createElement(Button, { onClick: OnConfirm, sx: {
                            //backgroundColor: "#00dd00 !important",
                            color: "#ffffff",
                            minWidth: "auto", // Ensure the button doesn't have a minimum width
                            padding: "8px", // Adjust padding as needed
                            marginRight: "10px",
                        } }, "Confirm")),
                React.createElement(Box, null,
                    React.createElement(Button, { onClick: OnCancel, sx: {
                            backgroundColor: "#000000 !important",
                            color: "#ffffff",
                            minWidth: "auto", // Ensure the button doesn't have a minimum width
                            padding: "8px", // Adjust padding as needed
                        } }, "Cancel")))),
        React.createElement(DialogActions, { sx: {
                position: "absolute",
                top: 0,
                right: 0,
                padding: 0, // Remove default padding
            } },
            React.createElement(Button, { onClick: OnCancel, sx: {
                    color: "#000000",
                    minWidth: "auto", // Ensure the button doesn't have a minimum width
                    padding: "8px", // Adjust padding as needed
                } },
                React.createElement(CloseIcon, null)))));
};
export default ConfirmationModal;
